import React from "react";

const URL_RE = /(https?:\/\/[^\s)]+)/g;

export const Linkified = ({ text }) => (
  <>
    {String(text || "").split(URL_RE).map((part, i) => (
      /^https?:\/\//.test(part)
        ? <a key={i} href={part} target="_blank" rel="noreferrer" className="underline text-[#00F0FF] break-all" data-testid="chat-link">{part}</a>
        : <React.Fragment key={i}>{part}</React.Fragment>
    ))}
  </>
);
